import { Dispatch, SetStateAction } from 'react';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { IRequestWithCallBack } from '~/Hooks/useRequest';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IOrderline } from '~/Models/DTO/Orderline.models';

export const getCustomerOrderLines = (
  request: IRequestWithCallBack,
  domain: string,
  customerId: string,
  setData: (data: IOrderline[]) => void,
  setError: Dispatch<SetStateAction<IErrorResponse>>,
) => {
  request<IOrderline[]>(
    {
      url: routeReplacer(CORE_SERVICE_URLS.CUSTOMER_ORDERLINES, {
        domain,
        customerId,
      }),
      method: 'GET',
    },
    setData,
    setError,
  );
};
